import { FC } from "react";
import { Box, Button, Flex, Heading, Spinner, Text } from "@radix-ui/themes";
import { useFindWinner } from "../hooks/useFindRaffleWinner";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import RaffleUIItem from "./raffle.ui.item";
import { useFindParticipant } from "../hooks/useFindRaffleParticipant";

const RaffleUIPlayStation: FC = (): JSX.Element => {
  const { data, loading, error, findWinner } = useFindWinner();
  const {
    data: participant,
    loading: _loading,
    error: _error,
    findParticipant,
  } = useFindParticipant();

  return (
    <Flex direction="column" gap="9">
      {/* Winner */}
      <Box>
        <Heading as="h2" size="5">
          PlayStation 4 - 20th Anniversary Edition
        </Heading>
        <Text as="p" size="2" mb="4">
          Tryk på knappen for at finde en tilfældig vinder af PlayStation 4 -
          20th Anniversary Edition
        </Text>
        <Flex direction="column" gap="4" mb="4">
          <Box>
            <Button onClick={() => findWinner()} disabled={loading}>
              {loading ? (
                <Spinner />
              ) : data ? (
                "Find en ny vinder"
              ) : (
                "Find en vinder"
              )}
            </Button>
          </Box>
          {error && <FormErrorMessage text={error.message} isVisible />}
          {data && <RaffleUIItem {...data} />}
        </Flex>
      </Box>
      {/* Sony In-ear */}
      <Box>
        <Heading as="h2" size="5">
          Sony Inzone Buds gaming in-ear høretelefoner (sort)
        </Heading>
        <Text as="p" size="2" mb="4">
          Tryk på knappen for at finde en tilfældig vinder af Sony Inzone Buds
          gaming in-ear høretelefoner (sort)
        </Text>
        <Flex direction="column" gap="4">
          <Box>
            <Button onClick={() => findParticipant()} disabled={loading}>
              {_loading ? (
                <Spinner />
              ) : participant ? (
                "Find en ny vinder"
              ) : (
                "Find en vinder"
              )}
            </Button>
          </Box>
          {_error && <FormErrorMessage text={_error.message} isVisible />}
          {participant && <RaffleUIItem {...participant} />}
        </Flex>
      </Box>
    </Flex>
  );
};

export default RaffleUIPlayStation;
